import { WorkflowStageTaskList } from '~/features/workflowing/tasks/WorkflowStageTaskList';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function WorkflowStageTaskListRoute() {
	const { stayId } = useChart();
	return <WorkflowStageTaskList stayId={stayId} />;
}
